import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}
const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  icon
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} whileHover={{
    y: -10,
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  }} className="bg-white p-8 rounded-lg shadow-lg border border-gray-100 hover:border-red-200 transition-all duration-300" data-id="element-129">
      <div className="bg-red-600 text-white p-4 rounded-full w-16 h-16 flex items-center justify-center mb-6 transform transition-transform duration-300 hover:rotate-12" data-id="element-130">
        {icon}
      </div>
      <h3 className="text-xl font-bold mb-4" data-id="element-131">{title}</h3>
      <p className="text-gray-600 mb-6" data-id="element-132">{description}</p>
      <Link to="/services" className="text-red-600 font-medium flex items-center hover:text-red-700 transition-colors group" data-id="element-133">
        Learn More{' '}
        <ArrowRightIcon size={16} className="ml-2 transform transition-transform duration-300 group-hover:translate-x-2" data-id="element-134" />
      </Link>
    </motion.div>;
};
export default ServiceCard;